export default {
  namespaced: true,
  state: {
    showToast: false,
    toastTimer: null,
    toastDesc: ''
  },
  getters: {
    showToast: state => state.showToast,
    toastDesc: state => state.toastDesc
  },
  mutations: {
    showToast (state, toastDesc) {
      const duration = toastDesc === '打卡成功' ? 1500 : 3000
      if (state.toastTimer) {
        window.clearTimeout(state.toastTimer)
        state.toastTimer = null
      }
      state.toastDesc = toastDesc
      state.showToast = true
      state.toastTimer = window.setTimeout(() => {
        window.clearTimeout(state.toastTimer)
        state.toastTimer = null
        state.showToast = false
      }, duration)
    }
  }
}
